import { render, staticRenderFns } from "./ApiKeyBadges.vue?vue&type=template&id=24c946e9&scoped=true&"
import script from "./ApiKeyBadges.vue?vue&type=script&lang=js&"
export * from "./ApiKeyBadges.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeyBadges.vue?vue&type=style&index=0&id=24c946e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c946e9",
  null
  
)

export default component.exports